// extracted by mini-css-extract-plugin
export default {"all-products":"AllProducts_all-products__uRo2J"};